const myAccount = {
  label1: 'Acessos',
  label2: 'Minha conta',
  label3: 'Sair'
}

export default myAccount;
